// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptAdminsToChargeSystemData, AcceptAdminsToChargeSystemResponses, AcceptFacilityChargeSystemSetupData, AcceptFacilityChargeSystemSetupErrors, AcceptFacilityChargeSystemSetupResponses, AcceptHomeChargeSystemSetupData, AcceptHomeChargeSystemSetupErrors, AcceptHomeChargeSystemSetupResponses, AlterRfidAccessData, AlterRfidAccessResponses, AlterUserAccessData, AlterUserAccessResponses, ChangeAdminPasswordData, ChangeAdminPasswordResponses, ChangeAvailabilityForConnectorsData, ChangeAvailabilityForConnectorsResponses, CheckAuthenticationData, CheckAuthenticationResponses, CheckInviteData, CheckInviteResponses, ClearDisplayMessageData, ClearDisplayMessageResponses, CreateAutomaticReportData, CreateAutomaticReportResponses, CreateConnectorGroupData, CreateConnectorGroupResponses, CreateRfidData, CreateRfidResponses, CreateTokenData, CreateTokenResponses, DeleteAutomaticReportData, DeleteAutomaticReportResponses, DeleteConnectorGroupData, DeleteConnectorGroupResponses, DeleteKeyAccessToChargeSystemData, DeleteKeyAccessToChargeSystemResponses, DeleteRfidData, DeleteRfidResponses, DeleteUserAccessToChargeSystemData, DeleteUserAccessToChargeSystemResponses, EditRfidKeyNameData, EditRfidKeyNameResponses, GetAdminByIdData, GetAdminByIdErrors, GetAdminByIdResponses, GetAutomaticReportData, GetAutomaticReportResponses, GetAutomaticReportsData, GetAutomaticReportsResponses, GetChargeSystemAlertGroupsData, GetChargeSystemAlertGroupsResponses, GetChargeSystemConnectorsData, GetChargeSystemConnectorsResponses, GetChargeSystemImdData, GetChargeSystemImdResponses, GetChargeSystemImdUsersData, GetChargeSystemImdUsersResponses, GetChargeSystemSetupInfoData, GetChargeSystemSetupInfoErrors, GetChargeSystemSetupInfoResponses, GetInvoiceData, GetInvoiceResponses, GetInvoicesData, GetInvoicesOutstandingAmountsData, GetInvoicesOutstandingAmountsResponses, GetInvoicesResponses, GetLoggedInAdminData, GetLoggedInAdminErrors, GetLoggedInAdminResponses, GetOrganizationAdminsData, GetOrganizationAdminsErrors, GetOrganizationAdminsResponses, GetOrganizationInvitedAdminsData, GetOrganizationInvitedAdminsErrors, GetOrganizationInvitedAdminsResponses, GetP3InvitedUsersData, GetP3InvitedUsersErrors, GetP3InvitedUsersResponses, GetP3UserData, GetP3UserErrors, GetP3UserResponses, GetP3UsersData, GetP3UsersErrors, GetP3UsersResponses, GetPassTokenValidData, GetPassTokenValidResponses, GetReportData, GetReportResponses, GetReportsData, GetReportsResponses, GetRfidUsersData, GetRfidUsersResponses, GetVariablesData, GetVariablesResponses, InviteAdminsData, InviteAdminsResponses, InviteUserToChargeSystemData, InviteUserToChargeSystemResponses, ListAdminsData, ListAdminsErrors, ListAdminsResponses, ListChargeSystemsData, ListChargeSystemsResponses, ListConnectorStatusesData, ListConnectorStatusesResponses, LoginData, LoginResponses, PassWordResetData, PassWordResetResponses, RemoveAdminAccessData, RemoveAdminAccessResponses, ResendUserInviteData, ResendUserInviteResponses, ResetChargePointData, ResetChargePointResponses, RevokeAdminInviteData, RevokeAdminInviteResponses, RevokeUserInviteToChargeSystemData, RevokeUserInviteToChargeSystemResponses, SetChargeSystemChargersToDefaultData, SetChargeSystemChargersToDefaultResponses, SetChargeSystemImdData, SetChargeSystemImdResponses, SetChargeSystemImdUserData, SetChargeSystemImdUserResponses, SetChargeSystemInvoicingData, SetChargeSystemInvoicingResponses, SetDiscountForUserData, SetDiscountForUserResponses, SetDisplayMessageData, SetDisplayMessageResponses, SetP3LiveConsumptionData, SetP3LiveConsumptionResponses, SetUserInvoicingData, SetUserInvoicingResponses, StartChargingData, StartChargingResponses, StartPingChargerData, StartPingChargerResponses, StatusHistoryData, StatusHistoryResponses, StopChargingData, StopChargingResponses, StopPingChargerData, StopPingChargerResponses, UpdateAutomaticReportData, UpdateAutomaticReportResponses, UpdateChargeSystemAlertGroupData, UpdateChargeSystemAlertGroupResponses, UpdateChargeSystemConnectorData, UpdateChargeSystemConnectorResponses, UpdateConnectorGroupData, UpdateConnectorGroupResponses, UpdateConnectorGroupsData, UpdateConnectorGroupsResponses, UpdateLoggedInAdminData, UpdateLoggedInAdminErrors, UpdateLoggedInAdminResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Remove admin access for organization
 */
export const removeAdminAccess = <ThrowOnError extends boolean = false>(options?: Options<RemoveAdminAccessData, ThrowOnError>): RequestResult<RemoveAdminAccessResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<RemoveAdminAccessResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get admin data of the logged in admin
 */
export const getLoggedInAdmin = <ThrowOnError extends boolean = false>(options?: Options<GetLoggedInAdminData, ThrowOnError>): RequestResult<GetLoggedInAdminResponses, GetLoggedInAdminErrors, ThrowOnError> => (options?.client ?? client).get<GetLoggedInAdminResponses, GetLoggedInAdminErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/admin',
    ...options
});

/**
 * Update data of the logged in admin
 */
export const updateLoggedInAdmin = <ThrowOnError extends boolean = false>(options?: Options<UpdateLoggedInAdminData, ThrowOnError>): RequestResult<UpdateLoggedInAdminResponses, UpdateLoggedInAdminErrors, ThrowOnError> => (options?.client ?? client).patch<UpdateLoggedInAdminResponses, UpdateLoggedInAdminErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Change the password of the logged in admin
 */
export const changeAdminPassword = <ThrowOnError extends boolean = false>(options?: Options<ChangeAdminPasswordData, ThrowOnError>): RequestResult<ChangeAdminPasswordResponses, unknown, ThrowOnError> => (options?.client ?? client).patch<ChangeAdminPasswordResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/admin/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List admins visible to the logged in admin
 */
export const listAdmins = <ThrowOnError extends boolean = false>(options?: Options<ListAdminsData, ThrowOnError>): RequestResult<ListAdminsResponses, ListAdminsErrors, ThrowOnError> => (options?.client ?? client).get<ListAdminsResponses, ListAdminsErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/admins',
    ...options
});

/**
 * Get admin by id when visible to the logged in admin
 */
export const getAdminById = <ThrowOnError extends boolean = false>(options: Options<GetAdminByIdData, ThrowOnError>): RequestResult<GetAdminByIdResponses, GetAdminByIdErrors, ThrowOnError> => (options.client ?? client).get<GetAdminByIdResponses, GetAdminByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/admins/{id}',
    ...options
});

/**
 * Add email to anonymous admin and create ChargesystemSetup
 *
 * Add email to anonymous admin and create ChargesystemSetup
 */
export const acceptFacilityChargeSystemSetup = <ThrowOnError extends boolean = false>(options: Options<AcceptFacilityChargeSystemSetupData, ThrowOnError>): RequestResult<AcceptFacilityChargeSystemSetupResponses, AcceptFacilityChargeSystemSetupErrors, ThrowOnError> => (options.client ?? client).post<AcceptFacilityChargeSystemSetupResponses, AcceptFacilityChargeSystemSetupErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/anonymoussetup/facility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add phone number to anonymous admin and create ChargesystemSetup
 *
 * Add phone number to anonymous admin and create ChargesystemSetup
 */
export const acceptHomeChargeSystemSetup = <ThrowOnError extends boolean = false>(options: Options<AcceptHomeChargeSystemSetupData, ThrowOnError>): RequestResult<AcceptHomeChargeSystemSetupResponses, AcceptHomeChargeSystemSetupErrors, ThrowOnError> => (options.client ?? client).post<AcceptHomeChargeSystemSetupResponses, AcceptHomeChargeSystemSetupErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/anonymoussetup/home',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get information about the ChargesystemSetup
 *
 * Get information about the ChargesystemSetup
 */
export const getChargeSystemSetupInfo = <ThrowOnError extends boolean = false>(options: Options<GetChargeSystemSetupInfoData, ThrowOnError>): RequestResult<GetChargeSystemSetupInfoResponses, GetChargeSystemSetupInfoErrors, ThrowOnError> => (options.client ?? client).get<GetChargeSystemSetupInfoResponses, GetChargeSystemSetupInfoErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/anonymoussetup/{token}',
    ...options
});

/**
 * check if correct header
 */
export const checkAuthentication = <ThrowOnError extends boolean = false>(options?: Options<CheckAuthenticationData, ThrowOnError>): RequestResult<CheckAuthenticationResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CheckAuthenticationResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/authenticated',
    ...options
});

/**
 * get all alert groups
 *
 * get all alert groups
 */
export const getChargeSystemAlertGroups = <ThrowOnError extends boolean = false>(options: Options<GetChargeSystemAlertGroupsData, ThrowOnError>): RequestResult<GetChargeSystemAlertGroupsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetChargeSystemAlertGroupsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/alertgroup',
    ...options
});

/**
 * Modifies members of the charge system alert group
 */
export const updateChargeSystemAlertGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateChargeSystemAlertGroupData, ThrowOnError>): RequestResult<UpdateChargeSystemAlertGroupResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateChargeSystemAlertGroupResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/alertgroup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * clear display message
 *
 * clear display message
 */
export const clearDisplayMessage = <ThrowOnError extends boolean = false>(options: Options<ClearDisplayMessageData, ThrowOnError>): RequestResult<ClearDisplayMessageResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ClearDisplayMessageResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/charge-point/{cpId}/display-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * set display message
 *
 * set display message
 */
export const setDisplayMessage = <ThrowOnError extends boolean = false>(options: Options<SetDisplayMessageData, ThrowOnError>): RequestResult<SetDisplayMessageResponses, unknown, ThrowOnError> => (options.client ?? client).post<SetDisplayMessageResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/charge-point/{cpId}/display-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * reset chargepoint
 *
 * reset chargepoint
 */
export const resetChargePoint = <ThrowOnError extends boolean = false>(options: Options<ResetChargePointData, ThrowOnError>): RequestResult<ResetChargePointResponses, unknown, ThrowOnError> => (options.client ?? client).post<ResetChargePointResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/charge-point/{cpId}/reset',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * Update connector
 *
 * Update a chargesystems connector
 */
export const updateChargeSystemConnector = <ThrowOnError extends boolean = false>(options: Options<UpdateChargeSystemConnectorData, ThrowOnError>): RequestResult<UpdateChargeSystemConnectorResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateChargeSystemConnectorResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/connector/{cId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get status history
 *
 * get status history
 */
export const statusHistory = <ThrowOnError extends boolean = false>(options: Options<StatusHistoryData, ThrowOnError>): RequestResult<StatusHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<StatusHistoryResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/connector/{connector}/statusHistory',
    ...options
});

/**
 * Get charge system connectors
 *
 * Get all connectors for a charge system
 */
export const getChargeSystemConnectors = <ThrowOnError extends boolean = false>(options: Options<GetChargeSystemConnectorsData, ThrowOnError>): RequestResult<GetChargeSystemConnectorsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetChargeSystemConnectorsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/connectors',
    ...options
});

/**
 * Enabled or disabled live consumption for a chargeSystem
 *
 * Enabled or disabled live consumption for a chargeSystem
 */
export const setP3LiveConsumption = <ThrowOnError extends boolean = false>(options: Options<SetP3LiveConsumptionData, ThrowOnError>): RequestResult<SetP3LiveConsumptionResponses, unknown, ThrowOnError> => (options.client ?? client).post<SetP3LiveConsumptionResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/consumption',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set chargesystem connectors to a default state
 *
 * Set chargesystem connectors to a default state
 */
export const setChargeSystemChargersToDefault = <ThrowOnError extends boolean = false>(options: Options<SetChargeSystemChargersToDefaultData, ThrowOnError>): RequestResult<SetChargeSystemChargersToDefaultResponses, unknown, ThrowOnError> => (options.client ?? client).get<SetChargeSystemChargersToDefaultResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/default',
    ...options
});

/**
 * set user discount to chargeSystem
 *
 * set user discount to chargeSystem
 */
export const setDiscountForUser = <ThrowOnError extends boolean = false>(options: Options<SetDiscountForUserData, ThrowOnError>): RequestResult<SetDiscountForUserResponses, unknown, ThrowOnError> => (options.client ?? client).post<SetDiscountForUserResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/discount',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get charge-system imd
 *
 * get charge-system imd
 */
export const getChargeSystemImd = <ThrowOnError extends boolean = false>(options: Options<GetChargeSystemImdData, ThrowOnError>): RequestResult<GetChargeSystemImdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetChargeSystemImdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/imd',
    ...options
});

/**
 * set charge-system imd
 *
 * set charge-system imd
 */
export const setChargeSystemImd = <ThrowOnError extends boolean = false>(options: Options<SetChargeSystemImdData, ThrowOnError>): RequestResult<SetChargeSystemImdResponses, unknown, ThrowOnError> => (options.client ?? client).post<SetChargeSystemImdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/imd',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * Gets all charge-system imd user invoice reference
 *
 * Gets all charge-system imd user invoice reference
 */
export const getChargeSystemImdUsers = <ThrowOnError extends boolean = false>(options: Options<GetChargeSystemImdUsersData, ThrowOnError>): RequestResult<GetChargeSystemImdUsersResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetChargeSystemImdUsersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/imd/users',
    ...options
});

/**
 * Update charge-system imd user invoice reference
 *
 * Update charge-system imd user invoice reference
 */
export const setChargeSystemImdUser = <ThrowOnError extends boolean = false>(options: Options<SetChargeSystemImdUserData, ThrowOnError>): RequestResult<SetChargeSystemImdUserResponses, unknown, ThrowOnError> => (options.client ?? client).post<SetChargeSystemImdUserResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/imd/users/{userId}',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * set charge-system invoicing
 *
 * set charge-system invoicing
 */
export const setChargeSystemInvoicing = <ThrowOnError extends boolean = false>(options: Options<SetChargeSystemInvoicingData, ThrowOnError>): RequestResult<SetChargeSystemInvoicingResponses, unknown, ThrowOnError> => (options.client ?? client).post<SetChargeSystemInvoicingResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/invoicing',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * set user invoicing
 *
 * set user invoicing
 */
export const setUserInvoicing = <ThrowOnError extends boolean = false>(options: Options<SetUserInvoicingData, ThrowOnError>): RequestResult<SetUserInvoicingResponses, unknown, ThrowOnError> => (options.client ?? client).post<SetUserInvoicingResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{csId}/invoicing/user',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * Alter user access for the charge system
 */
export const alterUserAccess = <ThrowOnError extends boolean = false>(options: Options<AlterUserAccessData, ThrowOnError>): RequestResult<AlterUserAccessResponses, unknown, ThrowOnError> => (options.client ?? client).patch<AlterUserAccessResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{id}/access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * revoke user invite chargesystems
 */
export const revokeUserInviteToChargeSystem = <ThrowOnError extends boolean = false>(options: Options<RevokeUserInviteToChargeSystemData, ThrowOnError>): RequestResult<RevokeUserInviteToChargeSystemResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RevokeUserInviteToChargeSystemResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{id}/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * invite users to a chargesystems
 */
export const inviteUserToChargeSystem = <ThrowOnError extends boolean = false>(options: Options<InviteUserToChargeSystemData, ThrowOnError>): RequestResult<InviteUserToChargeSystemResponses, unknown, ThrowOnError> => (options.client ?? client).post<InviteUserToChargeSystemResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{id}/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * resend user invites for charge system
 */
export const resendUserInvite = <ThrowOnError extends boolean = false>(options: Options<ResendUserInviteData, ThrowOnError>): RequestResult<ResendUserInviteResponses, unknown, ThrowOnError> => (options.client ?? client).post<ResendUserInviteResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{id}/resend-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete user access from charge system
 */
export const deleteKeyAccessToChargeSystem = <ThrowOnError extends boolean = false>(options: Options<DeleteKeyAccessToChargeSystemData, ThrowOnError>): RequestResult<DeleteKeyAccessToChargeSystemResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteKeyAccessToChargeSystemResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{id}/rfid/{rfidKey}',
    ...options
});

/**
 * Delete user access from charge system
 */
export const deleteUserAccessToChargeSystem = <ThrowOnError extends boolean = false>(options: Options<DeleteUserAccessToChargeSystemData, ThrowOnError>): RequestResult<DeleteUserAccessToChargeSystemResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteUserAccessToChargeSystemResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-system/{id}/user/{phoneNumber}',
    ...options
});

/**
 * List accessible charge systems
 *
 * List all charge systems the admin has access to, including non-RFID user ids per charge system
 */
export const listChargeSystems = <ThrowOnError extends boolean = false>(options?: Options<ListChargeSystemsData, ThrowOnError>): RequestResult<ListChargeSystemsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListChargeSystemsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charge-systems',
    ...options
});

/**
 * Start charging
 */
export const startCharging = <ThrowOnError extends boolean = false>(options: Options<StartChargingData, ThrowOnError>): RequestResult<StartChargingResponses, unknown, ThrowOnError> => (options.client ?? client).patch<StartChargingResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charger/{id}/start',
    ...options
});

/**
 * Stop charging
 */
export const stopCharging = <ThrowOnError extends boolean = false>(options: Options<StopChargingData, ThrowOnError>): RequestResult<StopChargingResponses, unknown, ThrowOnError> => (options.client ?? client).patch<StopChargingResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/charger/{id}/stop',
    ...options
});

/**
 * Revoke admin invite for organization
 */
export const revokeAdminInvite = <ThrowOnError extends boolean = false>(options?: Options<RevokeAdminInviteData, ThrowOnError>): RequestResult<RevokeAdminInviteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<RevokeAdminInviteResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/invite-admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * invite admins to organizations or charge systems
 */
export const inviteAdmins = <ThrowOnError extends boolean = false>(options?: Options<InviteAdminsData, ThrowOnError>): RequestResult<InviteAdminsResponses, unknown, ThrowOnError> => (options?.client ?? client).put<InviteAdminsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/invite-admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get all invited app users
 */
export const getP3InvitedUsers = <ThrowOnError extends boolean = false>(options?: Options<GetP3InvitedUsersData, ThrowOnError>): RequestResult<GetP3InvitedUsersResponses, GetP3InvitedUsersErrors, ThrowOnError> => (options?.client ?? client).get<GetP3InvitedUsersResponses, GetP3InvitedUsersErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/invited-users',
    ...options
});

/**
 * Get a set of invoices for a charge system
 */
export const getInvoices = <ThrowOnError extends boolean = false>(options?: Options<GetInvoicesData, ThrowOnError>): RequestResult<GetInvoicesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetInvoicesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/invoices',
    ...options
});

/**
 * Get the outstanding amounts for a charge system
 */
export const getInvoicesOutstandingAmounts = <ThrowOnError extends boolean = false>(options?: Options<GetInvoicesOutstandingAmountsData, ThrowOnError>): RequestResult<GetInvoicesOutstandingAmountsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetInvoicesOutstandingAmountsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/invoices/outstanding-amounts',
    ...options
});

/**
 * Get the details of an invoice in a charge system
 */
export const getInvoice = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceData, ThrowOnError>): RequestResult<GetInvoiceResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetInvoiceResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/invoices/{invoiceId}',
    ...options
});

/**
 * check if token is valid and if admin exists
 */
export const checkInvite = <ThrowOnError extends boolean = false>(options: Options<CheckInviteData, ThrowOnError>): RequestResult<CheckInviteResponses, unknown, ThrowOnError> => (options.client ?? client).get<CheckInviteResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/isinvitevalid/token/{token}',
    ...options
});

/**
 * List connector statuses
 *
 * List all connectors with status and error information that the admin has access to
 */
export const listConnectorStatuses = <ThrowOnError extends boolean = false>(options?: Options<ListConnectorStatusesData, ThrowOnError>): RequestResult<ListConnectorStatusesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListConnectorStatusesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/list-connector-statuses',
    ...options
});

/**
 * Logs in current admin
 */
export const login = <ThrowOnError extends boolean = false>(options?: Options<LoginData, ThrowOnError>): RequestResult<LoginResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LoginResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List admins related to an organization
 */
export const getOrganizationAdmins = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationAdminsData, ThrowOnError>): RequestResult<GetOrganizationAdminsResponses, GetOrganizationAdminsErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationAdminsResponses, GetOrganizationAdminsErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{id}/admins',
    ...options
});

/**
 * List invited admins related to an organization
 */
export const getOrganizationInvitedAdmins = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationInvitedAdminsData, ThrowOnError>): RequestResult<GetOrganizationInvitedAdminsResponses, GetOrganizationInvitedAdminsErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationInvitedAdminsResponses, GetOrganizationInvitedAdminsErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{id}/admins/invitations',
    ...options
});

/**
 * Change availability
 *
 * Change availability for connectors
 */
export const changeAvailabilityForConnectors = <ThrowOnError extends boolean = false>(options: Options<ChangeAvailabilityForConnectorsData, ThrowOnError>): RequestResult<ChangeAvailabilityForConnectorsResponses, unknown, ThrowOnError> => (options.client ?? client).post<ChangeAvailabilityForConnectorsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{orgId}/changeAvailability',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get report data for some period
 */
export const getReport = <ThrowOnError extends boolean = false>(options: Options<GetReportData, ThrowOnError>): RequestResult<GetReportResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetReportResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{orgId}/report',
    ...options
});

/**
 * Create Visitor RFID-key user on organization level
 */
export const createRfid = <ThrowOnError extends boolean = false>(options: Options<CreateRfidData, ThrowOnError>): RequestResult<CreateRfidResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateRfidResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{orgId}/rfid',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * Delete Visitor RFID from organization
 */
export const deleteRfid = <ThrowOnError extends boolean = false>(options: Options<DeleteRfidData, ThrowOnError>): RequestResult<DeleteRfidResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteRfidResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{orgId}/rfid/{userId}',
    ...options
});

/**
 * Alter Visitor RFID-key user access on organization level
 */
export const alterRfidAccess = <ThrowOnError extends boolean = false>(options: Options<AlterRfidAccessData, ThrowOnError>): RequestResult<AlterRfidAccessResponses, unknown, ThrowOnError> => (options.client ?? client).patch<AlterRfidAccessResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{orgId}/rfid/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all automatic reports configurations for an organization
 */
export const getAutomaticReports = <ThrowOnError extends boolean = false>(options: Options<GetAutomaticReportsData, ThrowOnError>): RequestResult<GetAutomaticReportsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAutomaticReportsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{orgId}/settings/automatic-reports',
    ...options
});

/**
 * Create a new automatic-report configuration
 */
export const createAutomaticReport = <ThrowOnError extends boolean = false>(options: Options<CreateAutomaticReportData, ThrowOnError>): RequestResult<CreateAutomaticReportResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateAutomaticReportResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{orgId}/settings/automatic-reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an automatic report configuration
 */
export const deleteAutomaticReport = <ThrowOnError extends boolean = false>(options: Options<DeleteAutomaticReportData, ThrowOnError>): RequestResult<DeleteAutomaticReportResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteAutomaticReportResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{orgId}/settings/automatic-reports/{reportId}',
    ...options
});

/**
 * Get a single automatic report configuration for an organization
 */
export const getAutomaticReport = <ThrowOnError extends boolean = false>(options: Options<GetAutomaticReportData, ThrowOnError>): RequestResult<GetAutomaticReportResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAutomaticReportResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{orgId}/settings/automatic-reports/{reportId}',
    ...options
});

/**
 * Update automatic report configuration
 */
export const updateAutomaticReport = <ThrowOnError extends boolean = false>(options: Options<UpdateAutomaticReportData, ThrowOnError>): RequestResult<UpdateAutomaticReportResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateAutomaticReportResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organization/{orgId}/settings/automatic-reports/{reportId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update connector groups
 *
 * Update charge system connector groups
 */
export const updateConnectorGroups = <ThrowOnError extends boolean = false>(options: Options<UpdateConnectorGroupsData, ThrowOnError>): RequestResult<UpdateConnectorGroupsResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateConnectorGroupsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organizations/{organizationId}/charge-systems/{chargeSystemId}/connector-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create connector group
 *
 * Create a charge system connector group
 */
export const createConnectorGroup = <ThrowOnError extends boolean = false>(options: Options<CreateConnectorGroupData, ThrowOnError>): RequestResult<CreateConnectorGroupResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateConnectorGroupResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organizations/{organizationId}/charge-systems/{chargeSystemId}/connector-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove connector group and all its associations
 */
export const deleteConnectorGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteConnectorGroupData, ThrowOnError>): RequestResult<DeleteConnectorGroupResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteConnectorGroupResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organizations/{organizationId}/charge-systems/{chargeSystemId}/connector-groups/{connectorGroupId}',
    ...options
});

/**
 * Update connector group
 *
 * Update a charge system connector group
 */
export const updateConnectorGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateConnectorGroupData, ThrowOnError>): RequestResult<UpdateConnectorGroupResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateConnectorGroupResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/organizations/{organizationId}/charge-systems/{chargeSystemId}/connector-groups/{connectorGroupId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Starts or extends a ping period session for a connector's chargePoint. This will ensure that websocketOffline status is up-to-date.
 */
export const startPingCharger = <ThrowOnError extends boolean = false>(options?: Options<StartPingChargerData, ThrowOnError>): RequestResult<StartPingChargerResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StartPingChargerResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/ping/start',
    ...options
});

/**
 * Stops an ongoing ping period session
 */
export const stopPingCharger = <ThrowOnError extends boolean = false>(options?: Options<StopPingChargerData, ThrowOnError>): RequestResult<StopPingChargerResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StopPingChargerResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/ping/stop',
    ...options
});

/**
 * get report data for multiple chargesystems for a period
 */
export const getReports = <ThrowOnError extends boolean = false>(options?: Options<GetReportsData, ThrowOnError>): RequestResult<GetReportsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetReportsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/report/chargesystems',
    ...options
});

export const getPassTokenValid = <ThrowOnError extends boolean = false>(options: Options<GetPassTokenValidData, ThrowOnError>): RequestResult<GetPassTokenValidResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPassTokenValidResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/resetpassword/isvalidtoken/{id}/{passwordToken}',
    ...options
});

export const passWordReset = <ThrowOnError extends boolean = false>(options: Options<PassWordResetData, ThrowOnError>): RequestResult<PassWordResetResponses, unknown, ThrowOnError> => (options.client ?? client).post<PassWordResetResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/resetpassword/newpassword/{id}/{passwordToken}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createToken = <ThrowOnError extends boolean = false>(options: Options<CreateTokenData, ThrowOnError>): RequestResult<CreateTokenResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateTokenResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/resetpassword/{email}',
    ...options
});

/**
 * Get all Visitor RFID-key users
 */
export const getRfidUsers = <ThrowOnError extends boolean = false>(options?: Options<GetRfidUsersData, ThrowOnError>): RequestResult<GetRfidUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRfidUsersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/rfid-keys',
    ...options
});

/**
 * Update Vistor RFID Key name
 */
export const editRfidKeyName = <ThrowOnError extends boolean = false>(options: Options<EditRfidKeyNameData, ThrowOnError>): RequestResult<EditRfidKeyNameResponses, unknown, ThrowOnError> => (options.client ?? client).put<EditRfidKeyNameResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/rfid-keys/{userId}',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * Accept an admin to a chargesystem
 */
export const acceptAdminsToChargeSystem = <ThrowOnError extends boolean = false>(options: Options<AcceptAdminsToChargeSystemData, ThrowOnError>): RequestResult<AcceptAdminsToChargeSystemResponses, unknown, ThrowOnError> => (options.client ?? client).post<AcceptAdminsToChargeSystemResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/token/{token}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all app users
 */
export const getP3Users = <ThrowOnError extends boolean = false>(options?: Options<GetP3UsersData, ThrowOnError>): RequestResult<GetP3UsersResponses, GetP3UsersErrors, ThrowOnError> => (options?.client ?? client).get<GetP3UsersResponses, GetP3UsersErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/users',
    ...options
});

/**
 * Get app user by id in a charge system
 */
export const getP3User = <ThrowOnError extends boolean = false>(options: Options<GetP3UserData, ThrowOnError>): RequestResult<GetP3UserResponses, GetP3UserErrors, ThrowOnError> => (options.client ?? client).get<GetP3UserResponses, GetP3UserErrors, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/users/{id}',
    ...options
});

/**
 * get cp config
 *
 * get configuration of chargepoint
 */
export const getVariables = <ThrowOnError extends boolean = false>(options: Options<GetVariablesData, ThrowOnError>): RequestResult<GetVariablesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetVariablesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Authorization', type: 'apiKey' }],
    url: '/variables/{cpId}/{parameter}',
    ...options
});
